module.exports = __webpack_public_path__ + "static/media/italy.604345b4.svg";